module.exports = __webpack_public_path__ + "static/media/open_drawer.02cf26df.svg";